var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#1EA1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.633 11.978C23.646 12.153 23.646 12.327 23.646 12.501C23.646 17.826 19.593 23.962 12.186 23.962C9.904 23.962 7.784 23.301 6 22.153C6.324 22.19 6.636 22.203 6.973 22.203C8.78599 22.2074 10.5476 21.6011 11.974 20.482C11.1334 20.4668 10.3186 20.1895 9.64324 19.6887C8.9679 19.188 8.46578 18.4889 8.207 17.689C8.456 17.726 8.706 17.751 8.968 17.751C9.329 17.751 9.692 17.701 10.029 17.614C9.11676 17.4298 8.29647 16.9353 7.70762 16.2147C7.11876 15.494 6.79769 14.5916 6.799 13.661V13.611C7.336 13.91 7.959 14.097 8.619 14.122C8.06609 13.7546 7.61272 13.256 7.29934 12.6708C6.98596 12.0856 6.82231 11.4319 6.823 10.768C6.823 10.02 7.022 9.334 7.371 8.736C8.38314 9.98102 9.6455 10.9996 11.0763 11.7257C12.5072 12.4518 14.0746 12.8692 15.677 12.951C15.615 12.651 15.577 12.34 15.577 12.028C15.5767 11.499 15.6807 10.9751 15.8831 10.4862C16.0854 9.99742 16.3821 9.55327 16.7562 9.17919C17.1303 8.8051 17.5744 8.50841 18.0632 8.30608C18.5521 8.10375 19.076 7.99974 19.605 8C20.765 8 21.812 8.486 22.548 9.272C23.4498 9.09762 24.3145 8.76842 25.104 8.299C24.8034 9.22982 24.1738 10.0191 23.333 10.519C24.1328 10.4278 24.9144 10.2175 25.652 9.895C25.1011 10.6981 24.4185 11.4023 23.633 11.978V11.978Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRounded);
export default __webpack_public_path__ + "static/media/twitter-rounded.c42bb4bb.svg";
export { ForwardRef as ReactComponent };